let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("csshn")).then(() => parcelRequire('ahYKy'));